<!-- eslint-disable max-len -->
<template>
  <div>
    <v-server-table
      v-show="load_first"
      ref="tableServer"
      :columns="columns"
      :options="options"
      class="jTable"
      @loading="loading"
      @loaded="loaded"
      @row-click="openEditModal">
      <div
        slot="beforeFilter"
        class="custom-search">
        <b-form inline>
          <b-button
            v-if="!readOnly"
            class="btn grey btn-import-form m__r--5"
            @click="$refs.modalCreate.show();
                    showAdditionalInfo = true;">
            <i class="fa fa-plus fa-lg"/> Add
          </b-button>
        </b-form>
      </div>

      <div
        slot="status"
        slot-scope="props">
        {{ props.row.status.toUpperCase() }}
      </div>
    </v-server-table>
    <jLoadingTable v-if="!load_first"/>

    <b-modal
      ref="modalCreate"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">Create Data Pelanggaran</h2>
      <b-row>
        <b-col md="12">
          <b-form-group :class="{'error-input' : $v.data_master.semester.$error}">
            <label> Semester </label>
            <j-single-select
              v-model="$v.data_master.semester.$model"
              :options="list_semester"
              :placeholder="'Select Semester'"
              label="name"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.title.$error}">
            <label> Judul Pelanggaran </label>
            <j-single-select
              v-model="$v.data_master.title.$model"
              :options="list_pelanggaran"
              :placeholder="'Judul Pelanggaran'"
              label="nama"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.attachment.$error}">
            <label> Attachment </label>
            <j-upload-file
              v-if="showAdditionalInfo"
              v-model="$v.data_master.attachment.$model"
              :accepted-file-type="['pdf', 'jpg', 'png', 'jpeg']"
              :api-token="token"
              :img-default="$v.data_master.attachment.$model"
              :url-upload="url_upload"
              @url="getUrl"/>
          </b-form-group>

          <!-- <b-form-group :class="{'error-input' : $v.data_master.attachment.$error}">
            <label> File </label><br>
            <j-singleupload
              v-model="$v.data_master.attachment.$model"
              :accepted-file-type="['pdf', 'jpg', 'png', 'jpeg']"
              :api-token="token"
              :img-default="$v.data_master.attachment.$model"
              :url-upload="url_upload"
              @url="getUrl"/>
            <label>
              Please choose file with supported format file pdf, jpg, png, jpeg.
            </label>
          </b-form-group> -->

          <j-form-base
            v-if="showAdditionalInfo"
            ref="jFormCreate"
            :data-fields="dataFields"/>
        </b-col>
      </b-row>

      <div class="float-to-right m__t--20">
        <b-button
          class="btn blue m__r--5"
          @click="saveData">
          Save
        </b-button>
        <b-button
          class="btn gray"
          @click="closeModalCreate">
          Cancel
        </b-button>
      </div>
    </b-modal>

    <b-modal
      ref="modalUpdate"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">Update Data Pelanggaran</h2>
      <b-row>
        <b-col md="12">
          <b-form-group :class="{'error-input' : $v.data_master.semester.$error}">
            <label> Semester </label>
            <j-single-select
              v-model="$v.data_master.semester.$model"
              :options="list_semester"
              :placeholder="'Select Semester'"
              :disabled="data_master.status !== 'draft' || readOnly"
              label="name"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.title.$error}">
            <label> Judul Pelanggaran </label>
            <j-single-select
              v-model="$v.data_master.title.$model"
              :options="list_pelanggaran"
              :placeholder="'Judul Pelanggaran'"
              :disabled="data_master.status !== 'draft' || readOnly"
              label="nama"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.attachment.$error}">
            <label> Attachment </label>
            <j-upload-file
              v-if="showAdditionalInfo"
              v-model="$v.data_master.attachment.$model"
              :accepted-file-type="['pdf', 'jpg', 'png', 'jpeg']"
              :api-token="token"
              :img-default="$v.data_master.attachment.$model"
              :name-default="fileNameDefault"
              :url-upload="url_upload"
              :disabled="data_master.status !== 'draft' || readOnly"
              @url="getUrl"/>
          </b-form-group>

          <!-- <b-form-group :class="{'error-input' : $v.data_master.attachment.$error}">
            <label> File </label><br>
            <j-singleupload
              v-model="$v.data_master.attachment.$model"
              :accepted-file-type="['pdf', 'jpg', 'png', 'jpeg']"
              :api-token="token"
              :img-default="$v.data_master.attachment.$model"
              :url-upload="url_upload"
              @url="getUrl"/>
            <label>
              Please choose file with supported format file pdf, jpg, png, jpeg.
            </label>
          </b-form-group> -->

          <j-form-base
            v-if="showAdditionalInfo"
            ref="jFormUpdate"
            :data-fields="dataFields"
            :is-detail="true"
            :is-disabled="data_master.status !== 'draft' || readOnly"/>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="3">
          <b-button
            v-if="data_master.status === 'draft' && !readOnly"
            class="btn red m__t--20"
            @click="deleteData">
            Delete
          </b-button>
        </b-col>
        <b-col md="9">
          <div class="float-to-right m__t--20">
            <b-button
              v-if="data_master.status === 'draft' && !readOnly"
              class="btn green m__r--5"
              @click="submitData">
              Submit
            </b-button>
            <b-button
              v-if="data_master.status === 'draft' && !readOnly"
              class="btn blue m__r--5"
              @click="updateData">
              Update
            </b-button>
            <b-button
              class="btn gray"
              @click="closeModalUpdate">
              Cancel
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { mapActions, mapState } from 'vuex';
import { required, requiredIf } from 'vuelidate/lib/validators';
import { jPrivRoles } from '@/privilage/roles/jPrivRoles';

import jApiKesiswaan from '@/services/jApiKesiswaan';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';
import jFormBase from '@/views/kurikulum/additional-info/jFormBase';
import jUploadFile from '@/components/upload-file/jUploadFile';

export default {
  // eslint-disable-next-line
  name: 'jPelanggaran',
  components: {
    jLoadingTable,
    jFormBase,
    jUploadFile,
  },
  mixins: [
    jPrivRoles,
  ],
  props: {
  },
  data() {
    return {
      data_master: {
        nis: this.$route.params.nis,
        type: '',
        title: null,
        semester: null,
        category_id: '9',
        attachment: null,
        additional_info: [],
        tahunajaran: this.$route.params.tahunajaran.replace('-', '/'),
        kode_kelas: this.$route.params.kelas,
      },
      fileNameDefault: '',
      list_pelanggaran: [],

      token: (JSON.parse(localStorage.getItem('Token'))).value,
      list_semester: [
        { id: 'Ganjil', name: 'Ganjil' },
        { id: 'Genap', name: 'Genap' },
      ],
      dataFields: [],
      showAdditionalInfo: false,
      load_first: false,
      data_table: [],
      selected_rows: [],
      columns: ['id', 'title', 'nis', 'tahunajaran', 'semester', 'status'],
      options: {
        headings: {
          id: 'ID',
          title: 'TITLE',
          nis: 'NIS',
          tahunajaran: 'TAHUN AJARAN',
          semester: 'SEMESTER',
          status: 'STATUS',
        },
        texts: {
          filterPlaceholder: 'Search',
          limit: 'Rows per page',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        debounce: 1000,
        filterable: true,
        sortable: [],
        perPage: 10,
        perPageValues: [5, 10, 20, 50, 100],
        requestAdapter(data) {
          return {
            status: '',
            module_id: 5,
            category_id: 9,
            nis: data.nis,
            limit: data.limit,
            page: data.page,
            tahunajaran: data.tahunajaran,
          };
        },
        requestFunction(data) {
          const getList = jApiKesiswaan.getListDocument(data);
          return getList.catch((e) => {
            this.$store.dispatch('jStoreNotificationScreen/getProblemMessage', e.response.data.errors[0].message).bind(this);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.length ? data.length : 0,
          };
        },
      },
    };
  },
  computed: {
    url_upload() {
      return `${process.env.GATE_URL}file/upload`;
    },
  },
  watch: {
  },
  created() {
    this.getAdditionalInfo(9).then((res) => {
      this.dataFields = res.data.data.map(el => ({
        id: el.id,
        name: el.field_name,
        type: el.type,
        placeholder: el.placeholder,
        field_key: el.field_key,
        is_delete: false,
        is_editable: false,
        is_mandatory: false,
      }));
    });

    this.getListPelanggaran().then((res) => {
      this.list_pelanggaran = res.data.data;
    });
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleLoading', 'showLoading', 'hideLoading', 'toggleProblem']),
    ...mapActions('jStoreKesiswaan', ['getAdditionalInfo', 'createDocument', 'updateDocument', 'detailDocument', 'deleteDocument', 'submitDocument', 'getListPelanggaran']),

    getUrl(data) {
      this.data_master.attachment = data;
    },

    loading(val) {
      const a = val;
      a.nis = this.$route.params.nis;
      a.tahunajaran = this.$route.params.tahunajaran.replace('-', '/');

      if (this.load_first) {
        this.showLoading();
      }
    },

    loaded(data) {
      this.data_table = data.data.data;

      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },

    closeModalCreate() {
      this.$refs.modalCreate.hide();
      this.showAdditionalInfo = false;
      this.data_master = {
        nis: this.$route.params.nis,
        type: '',
        title: null,
        semester: null,
        category_id: '9',
        attachment: null,
        additional_info: [],
        tahunajaran: this.$route.params.tahunajaran.replace('-', '/'),
        kode_kelas: this.$route.params.kelas,
      };
      setTimeout(() => {
        this.$v.data_master.$reset();
      }, 1000);
    },

    closeModalUpdate() {
      this.$refs.modalUpdate.hide();
      this.showAdditionalInfo = false;
      this.data_master = {
        nis: this.$route.params.nis,
        type: '',
        title: null,
        semester: null,
        category_id: '9',
        attachment: null,
        additional_info: [],
        tahunajaran: this.$route.params.tahunajaran.replace('-', '/'),
        kode_kelas: this.$route.params.kelas,
      };
      setTimeout(() => {
        this.$v.data_master.$reset();
      }, 1000);
    },

    openEditModal(param) {
      this.$refs.modalUpdate.show();
      const dataPelanggaran = this.list_pelanggaran.find(f => f.nama === param.row.title);
      const params = {
        id: param.row.id,
      };
      this.detailDocument(params).then((res) => {
        this.data_master = {
          id: param.row.id,
          nis: this.$route.params.nis,
          type: '',
          semester: param.row.semester,
          title: dataPelanggaran ? dataPelanggaran.id : null,
          category_id: '9',
          attachment: param.row.attachment,
          additional_info: [],
          tahunajaran: this.$route.params.tahunajaran.replace('-', '/'),
          kode_kelas: this.$route.params.kelas,
          status: res.data.data.status,
        };
        this.dataFields = res.data.data.additional_info.map(el => ({
          id: el.id,
          name: el.field_name,
          type: el.type,
          placeholder: el.placeholder,
          field_key: el.field_key,
          value: el.value,
          is_delete: false,
          is_editable: false,
          is_mandatory: false,
        }));
        this.fileNameDefault = param.row.attachment_name || '-';
        this.showAdditionalInfo = true;
      });
    },

    saveData() {
      this.$v.data_master.$touch();
      if (!this.$v.data_master.$error) {
        this.$refs.jFormCreate.getData().then((params) => {
          const dataPelanggaran = this.list_pelanggaran.find(f => f.id === this.data_master.title);
          this.data_master.title = dataPelanggaran ? dataPelanggaran.nama : '';
          this.data_master.jenis_pelanggaran = dataPelanggaran ? dataPelanggaran.id : '';
          this.data_master.additional_info = params.map(e => ({
            field_key: e.field_key,
            value: e.value,
          }));
          this.createDocument(this.data_master).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$refs.tableServer.getData();
                this.closeModalCreate();
              }, 1500);
            }
          });
        });
      }
    },

    updateData() {
      this.$v.data_master.$touch();
      if (!this.$v.data_master.$error) {
        this.$refs.jFormUpdate.getData().then((params) => {
          const dataPelanggaran = this.list_pelanggaran.find(f => f.id === this.data_master.title);
          this.data_master.title = dataPelanggaran ? dataPelanggaran.nama : '';
          this.data_master.jenis_pelanggaran = dataPelanggaran ? dataPelanggaran.id : '';
          this.data_master.additional_info = params.map(e => ({
            field_key: e.field_key,
            value: e.value,
          }));
          this.updateDocument(this.data_master).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$refs.tableServer.getData();
                this.closeModalUpdate();
              }, 1500);
            }
          });
        });
      }
    },

    deleteData() {
      this.$swal({
        title: 'Delete Data',
        text: 'Are you sure want to delete this data?',
        showCancelButton: true,
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.value) {
          const param = {
            id: this.data_master.id,
          };
          this.deleteDocument(param).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$refs.tableServer.getData();
                this.closeModalUpdate();
              }, 1500);
            }
          });
        }
      });
    },

    submitData() {
      this.$swal({
        title: 'Submit Data',
        text: 'Are you sure want to submit this data?',
        showCancelButton: true,
        confirmButtonText: 'Submit',
      }).then((result) => {
        if (result.value) {
          const param = {
            id: this.data_master.id,
          };
          this.submitDocument(param).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$refs.tableServer.getData();
                this.closeModalUpdate();
              }, 1500);
            }
          });
        }
      });
    },
  },
  validations() {
    return {
      data_master: {
        semester: { required },
        title: { required },
        attachment: { },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/kesiswaan/buku-saku/tab-component/jPelanggaran.vue